import { Link } from "react-router-dom";

import { SiteLogoMark } from "@components";

export const NotFoundPage = () => {
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-6 py-16 text-center sm:py-24">
      <SiteLogoMark className="mb-2 h-14 w-14 opacity-90" />
      <p className="section-label">404</p>
      <h1 className="mt-3 font-display text-4xl font-semibold text-ink sm:text-5xl">
        This route left the jet stream
      </h1>
      <p className="mt-4 text-muted">
        We couldn&apos;t find a matching page — the link may be wrong, or this
        path sits outside the current flow.
      </p>

      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="btn-primary">
          Back home
        </Link>
        <Link to="/explore" className="btn-ghost">
          Explore
        </Link>
      </div>
    </div>
  );
};
